export default "__VITE_ASSET__BXVx4CK___"